export default "__VITE_ASSET__756486d7__"